import { getRouteApi, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';

import { definedSearchParams } from '@/lib/search-params';

import { GymCatalogScreen } from './GymCatalogScreen';
import type { GymCatalogSearch } from './gym-catalog-search';

const route = getRouteApi('/gym-catalog');

export function GymCatalogRoute() {
  const search = route.useSearch();
  const navigate = route.useNavigate();
  const navigateTo = useNavigate();

  const onSearchChange = useCallback(
    (next: GymCatalogSearch) => {
      void navigate({ replace: true, search: () => definedSearchParams(next) });
    },
    [navigate],
  );

  /**
   * The create page, named as the gyms wrote it, with the gym rows it stands
   * for: once the catalog row exists the page links them (a second call, as a
   * food request's create-then-resolve is).
   */
  const onMakeFood = useCallback(
    (name: string, gymFoodIds: readonly string[]) => {
      void navigateTo({ to: '/foods/new', search: { name, gymFoodIds: gymFoodIds.join(',') } });
    },
    [navigateTo],
  );

  const onMakeExercise = useCallback(
    (name: string, gymExerciseIds: readonly string[]) => {
      void navigateTo({ to: '/exercises/new', search: { name, gymExerciseIds: gymExerciseIds.join(',') } });
    },
    [navigateTo],
  );

  const onOpenFood = useCallback(
    (foodId: string) => {
      void navigateTo({ to: '/foods/$foodId', params: { foodId } });
    },
    [navigateTo],
  );

  return (
    <GymCatalogScreen
      search={search}
      onSearchChange={onSearchChange}
      onMakeFood={onMakeFood}
      onMakeExercise={onMakeExercise}
      onOpenFood={onOpenFood}
    />
  );
}
